$(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
        $('#shopify-section-header').addClass('shopify-section-header-hidden shopify-section-header-sticky animate');
    } else {
        $('#shopify-section-header').removeClass('shopify-section-header-hidden shopify-section-header-sticky animate');
    }
});
// Product slider
$(document).ready(function(){
    setTimeout(function(){
     $("img.lazyload").each(function(){
            $(this).attr("src",$(this).attr("data-src")).removeAttr("data-src");
        }); 
  },500);
  $('.blog-product.featured-collection .product-grid').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    accessibility: false,
    dots:false,
    arrows:true,
    prevArrow: '<button class="slide-arrow prev-arrow" aria-label="Previous slide"><svg id="arrow-left" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><rect id="Rectangle_82" data-name="Rectangle 82" width="32" height="32" fill="rgba(255,255,255,0.01)"/><path id="Path_67" data-name="Path 67" d="M3.866,16h24" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/><path id="Path_68" data-name="Path 68" d="M11.866,24l-8-8,8-8" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow" aria-label="Next slide"><svg id="arrow-left" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><rect id="Rectangle_82" data-name="Rectangle 82" width="32" height="32" fill="rgba(255,255,255,0.01)"/><path id="Path_67" data-name="Path 67" d="M27.866,16h-24" transform="translate(0.268)" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/><path id="Path_68" data-name="Path 68" d="M3.866,24l8-8-8-8" transform="translate(16.268)" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/></svg></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 481,
        settings: {
          slickSetOption: true,
          slidesToShow: 1,
          mobileFirst: true,
          slidesToScroll: 1
        }
      }
    ]
  }).find('[aria-hidden]').removeAttr('aria-hidden').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        setTimeout(() => {
            slick.$slides.removeAttr('aria-hidden');
        }, 0);
    });

  $('.featured-collection .product-grid').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    accessibility: false,
    dots:false,
    arrows:true,
    prevArrow: '<button class="slide-arrow prev-arrow" aria-label="Previous slide"><svg id="arrow-left" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><rect id="Rectangle_82" data-name="Rectangle 82" width="32" height="32" fill="rgba(255,255,255,0.01)"/><path id="Path_67" data-name="Path 67" d="M3.866,16h24" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/><path id="Path_68" data-name="Path 68" d="M11.866,24l-8-8,8-8" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow" aria-label="Next slide"><svg id="arrow-left" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><rect id="Rectangle_82" data-name="Rectangle 82" width="32" height="32" fill="rgba(255,255,255,0.01)"/><path id="Path_67" data-name="Path 67" d="M27.866,16h-24" transform="translate(0.268)" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/><path id="Path_68" data-name="Path 68" d="M3.866,24l8-8-8-8" transform="translate(16.268)" fill="none" stroke="#63666a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.333"/></svg></button>',    
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 481,
        settings: "unslick"
      }
    ]
  }).find('[aria-hidden]').removeAttr('aria-hidden').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        setTimeout(() => {
            slick.$slides.removeAttr('aria-hidden');
        }, 0);
    });

  $(window).on('resize', function() {
  if ($(window).width() < 480) {
    if ($('.featured-collection .product-grid').hasClass('slick-initialized'))
      $('.featured-collection .product-grid').slick('unslick');
    return
  }
});  

  // Recharge Page
  $('.slideout-panel .rct_navigation__desktop').prepend('<a class="back-link" href="/account">My account</a>');
  $('.slideout-panel .rct_navigation').append('<a class="back-link" href="/account">My account</a>');
  $('#customer_tab_content .rc_header-settings').append('<a class="back-link" href="/account">My account</a>');  

  // Logo with text slider
    $(document).ready(function(){
    $(window).resize(function(){
      if($(window).width() < 480) {
        $('.logo-wrapper').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:false,
          arrows:false,
          accessibility: false,
          responsive: [
            {
              breakpoint: 992,
              settings: "unslick"
            },
            {
              breakpoint: 481,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        }).find('[aria-hidden]').removeAttr('aria-hidden').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            setTimeout(() => {
                slick.$slides.removeAttr('aria-hidden');
            }, 0);
        });
      }
    });
  }); 


  // Blog Slider
  // infinite:false so Slick does not clone slides (clones duplicated each article's <h3>,
  // creating repeated headings). Navigation is dots-only (no arrows/autoplay), so disabling
  // the loop has no visible effect on load.
  $('.blog-slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:true,
    accessibility: false,
    arrows:false
  }).find('[aria-hidden]').removeAttr('aria-hidden').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      setTimeout(() => {
          slick.$slides.removeAttr('aria-hidden');
      }, 0);
  });

  // Product tab structure
  $('.description_tab .tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');
    $('.description_tab .tabs li').removeClass('current');
    $('.tab_content').removeClass('current');
    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });

  // Set Product review attr
  var id = $('.yotpo-main-widget').data('product-id');
  $('.yotpo-main-widget').attr('id',id);

  // Product page slider
  $('.product__media-list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    draggable:false,
    fade: true,    
    accessibility: false,
    adaptiveHeight: true,
    asNavFor: '.thumbnail-list ',
    dots: true
  }).find('[aria-hidden]').removeAttr('aria-hidden').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      setTimeout(() => {
          slick.$slides.removeAttr('aria-hidden');
      }, 0);
  });
  
  $('.thumbnail-list ').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    asNavFor: '.product__media-list',
    dots: false,
    arrows:false,
    centerMode: false,
    focusOnSelect: true,
    accessibility: false,
    infinite: false,
    vertical: true,
    verticalSwiping: true,
    prevArrow: '<button class="slide-arrow prev-arrow" aria-label="Previous slide"><svg x="0px" y="0px"viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;"><path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow" aria-label="Next slide"><svg x="0px" y="0px"viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;"><path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"/></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          verticalSwiping: false
        }
      }
    ]
  }).find('[aria-hidden]').removeAttr('aria-hidden').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      setTimeout(() => {
          slick.$slides.removeAttr('aria-hidden');
      }, 0);
  });

  // Product page add class in review section
  $('.product .yotpo-main-widget').parents('.section').addClass('product-review');
  $('.product .yotpo-main-widget').parents('.section').attr('id','product-review');

  // Modal
  $('.popUpBtn').on('click', function(){
    $('#'+$(this).data('modal')).css('display','block');
  });
  $('span.close').on('click', function(){
    $('.modal').css('display','none');
  });
  $(window).on('click', function(event){
    if (jQuery.inArray( event.target, $('.modal') ) != "-1") {
      $('.modal').css('display','none');
    }
  });

  // Ingredients  Modal
  $('.ingredients-heading a,.ingredient-info a').on('click', function(){
    $('#'+$(this).data('modal')).css('display','flex');
    $('body').addClass('open-modal');
  });
  $('.modal-close').on('click', function(){
    $('.modal').css('display','none');
    $('body').removeClass('open-modal');
  });
  $(window).on('click', function(event){
    if (jQuery.inArray( event.target, $('.modal') ) != "-1") {
      $('.modal').css('display','none');
      $('body').removeClass('open-modal');
    }
  });


  // Blog page filter
  var e = [],
      t = "";
  $('.tag-group input[type="radio"]').change(function (o) {
    o.preventDefault(),
      setTimeout(function () {
      (e = []),
        $(".tag-group input:checked").each(function () {     
        $('.reset-filter').addClass('show-btn');
        e.push($(this).val());
      });
      var n = e.join("+"),
          a = location.pathname,
          l = location.origin,
          u = l + a + "/tagged/" + n;

      $.ajax({
        url: u,
        type: "GET",
        success: function (d) {
          setTimeout(function() {
            $('.tag-group').slideToggle();
            $("#article-info").html($(d).find("#article-info").html());
            $('body').removeClass('filter-open');
            $('.blog-top-filter').removeClass('open');
            var BlogLength = $('.blog-articles__article').length;
            $('.blog-articles__article').addClass('full-width-blog');
            if (BlogLength > 10) {
              $('.pagination-wrapper').show();
            }else{
              $('.pagination-wrapper').hide();
            }
          }, 500);
        },
      });
    }, 200);
  });
  
  if ($(window).width() < 768) {
  }
  else {
    $('.filter-group-body h3').click(function(){    
      $(this).next('.tag-group').slideToggle();
      $("ul.tag-group").not($(this).next()).slideUp(500);    
    });
    $('.blog-sort h3').click(function(){    
      $(this).next('.tag-group').slideToggle();
      $("ul.tag-group").not($(this).next()).slideUp(500);    
    });
  }

  $('.mobile-filter-handle span').click(function(){
    $('body').addClass('filter-open');
    $('.blog-top-filter').addClass('open');
  });
  $('.filter-overlay,.filter-close').click(function(){
    $('body').removeClass('filter-open');
    $('.blog-top-filter').removeClass('open');
  });

  $(".yotpo-rule").text(function () {
    return $(this).text().replace("equals", "="); 
  });
  setTimeout(function(){
    $(".yotpo-rule").text(function () {
      return $(this).text().replace("equals", "="); 
    });
  }, 2000);

  // Product Listing page

  var categoryLength = $('.category-group li').length;
  // var concernLength = $('.concern-group li').length;
  if(categoryLength == 0){
      $('.category-group').parents('.collection-filter-group').hide();
  }

  
  if ($(window).width() < 768) {
  }
  else {
    $('.collection-new-filter .collection-filter-heading').click(function(event){
      $(this).next('.collection-filter-group ul').slideToggle();
      $(".collection-filter-group ul").not($(this).next()).slideUp(500);    
      event.stopPropagation();
    });
  }

  $('.mobile-filter-handle span').click(function(){
    $('body').addClass('filter-open');
    $('.main-collection-filter').addClass('open');
  });
  $('.filter-overlay,.filter-close').click(function(){
    $('body').removeClass('filter-open');
    $('.main-collection-filter').removeClass('open');
  });

  var e = [],
      t = "";
  $('.collection-sidebar__filter-item input[type="radio"]').change(function (o) {
    o.preventDefault(),
      setTimeout(function () {
      (e = []),
        $(".collection-sidebar__filter-item input:checked").each(function () {
        e.push($(this).val());
      });
      var n = e.join("+"),
          a = location.pathname,
          l = location.origin,
          u = l + a + "/" + n;
        console.log(u);

      $.ajax({
        url: u,
        type: "GET",
        success: function (d) {
          $('.collection .filter-loader').css({"opacity": "1", "visibility": "visible"});
          $("#product-grid").css({"opacity": "0", "visibility": "hidden"});
          setTimeout(function() {
            $('.collection .filter-loader').css({"opacity": "0", "visibility": "hidden"});
            $("#product-grid").css({"opacity": "1", "visibility": "visible"});
            $('.collection-tag-group').slideUp();
            $("#product-grid").html($(d).find("#product-grid").html());
            $('body').removeClass('filter-open');
            $('.main-collection-filter').removeClass('open');
            $('.quick-view').click(function(){
          		var tab_id = $(this).attr('data-handle');
          		$('.quickview-popup').removeClass('current');
          		$("#"+tab_id).addClass('current');
                    $('body').addClass('modal-open');
                   $('.qvproductimages').slick('setPosition');
          	});
          }, 800);
        },
      });
    }, 200);
  });  
  $('.qvproductimages').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:false,
    arrows:false
  });
  $('.quick-view').click(function(){
      var tab_id = $(this).attr('data-handle');
      $('.quickview-popup').removeClass('current');
      $("#"+tab_id).addClass('current');
      $('body').addClass('modal-open');
      $('.qvproductimages').slick('setPosition');
  });

  $('.addtocart.qv-add-button').click(function(){
    $('body').removeClass('modal-open');
    $('.quickview-popup').removeClass('current');
  });

  $('.quickview-close').click(function(){
    $('body').removeClass('modal-open');
    $('.quickview-popup').removeClass('current');
  });  
  
  $('.variant-radio-wrapper input').change(function(){
      var SelectID = $(this).data('id');
      var Inventory = $(this).data('variant-inventory-qty');
      var ProductID = $('.quickview').data('product');
      $(this).parents('form').find('.variant-id').val(SelectID);
      var SelectValue = $(this).data('price');
      $(this).parents('.quickview-body-wrapper').find('.qvproduct-price-wrapper .qvproduct-price').text(SelectValue);
      $(this).parents('.quickview-body-wrapper').find('.qv-add-button .cart-price').text(SelectValue);
      var SelectedVal = $(this).val();
      $(this).parents('form').find('.variant-label-wrapper .qv-variant-title').text(SelectedVal);
      var Quantity = $(this).parents('.qvadd-to-cart').find('.quantity__input').val('1');
      if(Inventory <= 0){
         $(this).parents('.qvcontent').find('.qv-add-button').addClass('sold-out')
      }else{
         $(this).parents('.qvcontent').find('.qv-add-button').removeClass('sold-out')
      }

      var dataId = $(this).closest('.quickview-body-wrapper').find('.selling-plans[data-variant='+ SelectID +']').attr('data-variant');
      if(dataId == SelectID){
        $(this).parents('.quickview-body-wrapper').find('.selling-plans').addClass('selling-plan-hide');
        $(this).parents('.quickview-body-wrapper').find('.selling-plans[data-variant='+ SelectID +']').removeClass('selling-plan-hide')
      }
  });

    $('.quickview .quantity__button').click(function(){
        var Quantity = $(this).parents('.quantity').find('.quantity__input').val();
        if($(this).parents('.qvadd-to-cart').hasClass('default__title')){
          var ProductPrice = $(this).parents('.quickview-body-wrapper').find('.qvproduct-price').text();
          var unit = ProductPrice.replace(/[^\d.]/g, '');
          var total = unit * Quantity;
          $('.qv-add-button .cart-price').text('$'+total);
        }else{
          var ProductPrice = $(this).parents('.qvadd-to-cart').find('.variant-radio-wrapper input:checked').data('price');
          var unit = ProductPrice.replace(/[^\d.]/g, '');
          var total = unit * Quantity;
          $('.qv-add-button .cart-price').text('$'+total);
        }
        
    });

    $('.blog-product').each(function(){
      $('.quickview .quantity__button').click(function(){
        var Quantity = $(this).parents('.quantity').find('.quantity__input').val();
        var ProductPrice = $(this).parents('.qvadd-to-cart').find('.variant-radio-wrapper input:checked').data('price');
        var unit = ProductPrice.replace(/[^\d.]/g, '');
        var total = unit * Quantity;
        $(this).parents('.qvadd-to-cart').find('.qv-add-button .cart-price').text('$'+total);
        $(this).parents('.qvcontent').find('.quantity').val(Quantity);
      });
    });

    $('.quickview .quantity__input').keyup(function(){
        var Quantity = $(this).val();
        var ProductPrice = $(this).parents('.qvadd-to-cart').find('.variant-radio-wrapper input:checked').data('price');
        var unit = ProductPrice.replace(/[^\d.]/g, '');
        var total = unit * Quantity;
        $('.qv-add-button .cart-price').text('$'+total);
        $(this).parents('.qvcontent').find('.quantity').val(Quantity);
    });

  // Checkbox checked
  $('.checkbox-wrapper input[type="checkbox"]').change(function(){
      var InputValue = $(this).val();
      if($(this).prop("checked") == true){
        if(InputValue == 'Multi-door-Retailer'){
          $('.location').attr('readonly', false);
        }
        if(InputValue == 'Other'){
          $('.specify').attr('readonly', false);
        }
      }
      else if($(this).prop("checked") == false){
        if(InputValue == 'Multi-door-Retailer'){
          $('.location').attr('readonly', true);
         $(".location").val('');
        }
        if(InputValue == 'Other'){
          $('.specify').attr('readonly', true);
           $(".specify").val('');
        }
      }
  });

  // Retailer Page
  setTimeout(function() {
    $('[data-default-value*="checkbox"],[data-connected-id="checkbox"]').wrapAll('<div class="checkbox-sec"></div>');
  }, 1000);

  setTimeout(function() {
    $('#beam-community-widget-container>div>div>div>div>div>div+div>div:last-child').removeAttr("style")
    $('#beam-community-widget-container #beam-loading-screen+div>div').removeAttr("style")
  }, 1200);

  // Footer Accordian
  if ($(window).width() < 768) {
    $('.footer-menu .h4').click(function() {
      if ($(this).hasClass("active")) {
          $(this).removeClass("active").parents('.footer-menu').find('ul').slideUp();
      } else {
          $(".footer-menu .h4.active").next().slideUp();
          $(".footer-menu .h4.active").removeClass("active");
          $(this).addClass("active").next().slideDown();
      }
      return false;
    });
  }

  // policy page search
   $("#filter").keyup(function(){
          var value = $(this).val().toLowerCase();
          let found = 0;
          $.each($(".policy-wrapper .policy-search"), function(i) {
             if($(this).text().toLowerCase().indexOf(value) === -1){
                 $(this).hide();
                 found++;
               }else{
                 $(this).show();
              }
          });
          if(found == $(".policy-wrapper .policy-search").length){
            $('.blank_wrapper').show();
            $('.policy-wrapper').hide();
          }else{
            $('.policy-wrapper').show();
            $('.blank_wrapper').hide();
          }
    });
});

$(document).on('DOMNodeInserted', function (e) {
  if ($(e.target).hasClass('yotpo-logged-in-view')) {
    $('.reward-loader').hide();
    $('.yotpo-vip-tiers-progress-bar-summary-current,.yotpo-vip-tiers-progress-bar-summary-next').wrapAll('<div class="status-body"></div>');
  }
});

$(document).ready(function(){
  $('.yotpo-vip-tiers-progress-bar-summary-current,.yotpo-vip-tiers-progress-bar-summary-next').wrapAll('<div class="status-body"></div>');
});

$(window).on('load',function(){
  $('.yotpo-vip-tiers-progress-bar-summary-current,.yotpo-vip-tiers-progress-bar-summary-next').wrapAll('<div class="status-body"></div>');
});


// Quiz Page
$(document).ready(function(){
  var quiz_options = {
    infinite: false,
    draggable: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    dots: false,
    fade: true,
    cssEase: 'linear',
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          touchThreshold : false
        }
      }
    ]
  }

  var options = {
    infinite: false,
    draggable: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    dots: false,
    fade: true,
    cssEase: 'linear',
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          touchThreshold: false
        }
      }
    ]
  }

  if($('.hair-quiz-body').hasClass('hair_quiz_first')){
    $('.hair_quiz_first').find('.quiz-btn a:first-child').addClass('main-back');
    $('.hair_quiz_first').find('.quiz-btn a:first-child').removeClass('back');
  }
  if($('.skin-quiz-body').hasClass('skin_quiz_first')){
    $('.skin_quiz_first').find('.quiz-btn a:first-child').addClass('main-back');
    $('.skin_quiz_first').find('.quiz-btn a:first-child').removeClass('back');
  }

  $('.quiz-title input').click(function(){
    if (this.value == 'skin_quiz') {
        $('.quiz-content').hide();
        $('.skin-quiz').show();
        $('.quiz-slider').slick('unslick');
        $('.quiz-slider').slick(options);
        $('.quiz-slider').slick('setPosition');
        $(".quiz-slider").on("init", function(event) {});
      }
      else if (this.value == 'hair_quiz') {
        $('.quiz-content').hide();
        $('.hair-quiz').show();
        $('.hair_quiz_slider').slick('unslick');
        $('.hair_quiz_slider').slick(options);
        $('.hair_quiz_slider').slick('setPosition');
        $(".hair_quiz_slider").on("init", function(event) {});
      }
  })
  
  $('.quiz-title input').change(function(){
      if (this.value == 'skin_quiz') {
        $('.quiz-content').hide();
        $('.skin-quiz').show();
        $('.quiz-slider').slick('unslick');
        $('.quiz-slider').slick(options);
        $('.quiz-slider').slick('setPosition');
        $(".quiz-slider").on("init", function(event) {});
        $('.back').click(function(){
           $(".quiz-slider").slick('slickPrev');
           $(".quiz-slider").on("init", function(event) {});
           $('html, body').animate({
             scrollTop: $('.skin-quiz-body').position().top
           }, 'slow'); 
        });
        $('.continue').click(function() {
          if($(this).parents('.skin-quiz-body').hasClass('slick-current')){
              if ($(this).parents('.skin-quiz-body').find('.quiz-radio input[type="radio"]').is(':checked')) {
                  $(".quiz-slider").slick('slickNext');
                  $('html, body').animate({
                    scrollTop: $('.skin-quiz-body').position().top
                  }, 'slow'); 
              }
            }
        });
      }
      else if (this.value == 'hair_quiz') {
        $('.quiz-content').hide();
        $('.hair-quiz').show();
        $('.hair_quiz_slider').slick('unslick');
        $('.hair_quiz_slider').slick(options);
        $('.hair_quiz_slider').slick('setPosition');
        $(".hair_quiz_slider").on("init", function(event) {});
        $('.back').click(function(){
          $(".hair_quiz_slider").slick('slickPrev');
          $(".hair_quiz_slider").on("init", function(event) {});
          $('html, body').animate({
             scrollTop: $('.hair-quiz-body').position().top
           }, 'slow'); 
        });
        $('.continue').click(function() {
          if($(this).parents('.hair-quiz-body').hasClass('slick-current')){
              if ($(this).parents('.hair-quiz-body').find('.quiz-radio input[type="radio"]').is(':checked')) {
                  $(".hair_quiz_slider").slick('slickNext');
                  $('html, body').animate({
                    scrollTop: $('.hair-quiz-body').position().top
                  }, 'slow'); 
              }
            }
        });
      }
  });  

  $('.quiz-slider').on('init', function() {});
  $('.quiz-slider').slick(quiz_options);
  
  $('.hair_quiz_slider').on('init', function() {});
  $('.hair_quiz_slider').slick(options);
  
  $('.quiz-slider .skin_quiz_first .main-back').click(function(e){
    $('.skin-quiz').hide();
    $('.quiz-content').show();
    $('html, body').animate({
      scrollTop: $('.quiz-content-wrapper').position().top - 150
    }, 'slow'); 
  });  
  $('.hair-quiz-body.skin_quiz_first .main-back').click(function(){
    $('.hair-quiz').hide();
    $('.quiz-content').show();
    $('html, body').animate({
      scrollTop: $('.quiz-content-wrapper').position().top - 150
    }, 'slow'); 
  });
  $('.quiz-email-body .error').hide();
  $('.contact__button button[type="submit"]').click(function(){
    var Email = $('.quiz-email-body #Contactemail').val();
    if(Email == ''){
      $('.quiz-email-body .error').show();
    }
  });
});

$(window).on('load',function() {
    $(".preloader").delay(1000).fadeOut("slow");
})

// Collection page read more & read less
function AddReadMore() {
    //This limit you can set after how much characters you want to show Read More.
    var carLmt = 900;
    // Text to show when text is collapsed
    var readMoreTxt = " ... Read More";
    // Text to show when text is expanded
    var readLessTxt = " Read Less";


    //Traverse all selectors with this class and manupulate HTML part to show Read More
    $(".addReadMore").each(function() {
        if ($(this).find(".firstSec").length)
            return;

        var allstr = $(this).text();
        if (allstr.length > carLmt) {
            var firstSet = allstr.substring(0, carLmt);
            var secdHalf = allstr.substring(carLmt, allstr.length);
            var strtoadd = firstSet + "<span class='SecSec'>" + secdHalf + "</span><span class='readMore'  title='Click to Show More'>" + readMoreTxt + "</span><span class='readLess' title='Click to Show Less'>" + readLessTxt + "</span>";
            $(this).html(strtoadd);
        }

    });
    //Read More and Read Less Click Event binding
    $(document).on("click", ".readMore,.readLess", function() {
        $(this).closest(".addReadMore").toggleClass("showlesscontent showmorecontent");
    });
}
$(function() {
    //Calling function after Page Load
    AddReadMore();
});